import LearningService from '@/plugins/services/learning';
import { sessionStore } from '@/common/utils/storage';
import CourseProgressStorage from '@/common/utils/storages/course-progress';

class LearngingReport {
  constructor(options) {
    // 上报视频唯一标识
    this.key = options.key;
    this.postType = options.postType;
    this.postId = options.postId;
    this.videoDuration = options.videoDuration;
    // 开始播放时间戳 用于统计播放时长
    this.startTimeStamp = 0;
    // 当前会话累次播放时长
    this.duration = 0;
    // 暂停标记，防止暂停时播放进度回调累加暂停记录的时间
    this.isPause = true;
    // 由于视频是播放之后才开始加载的，所以为了更精确统计累计时长，需要一个播放按钮的标志位，统计由进度条回调进行
    this.isFirstRun = false;

    this.reportHook = options.reportHook || null;
  }

  // video开始播放
  play() {
    this.isFirstRun = true;
    this.isPause = false;
  }

  // video暂停播放
  async pause() {
    // 暂停是禁止累计时间
    this.duration += new Date().getTime() - this.startTimeStamp;
    this.startTimeStamp = 0;
    this.isPause = true;
  }

  // 时长累计
  durationJudgment() {
    return this.duration / 1000 / this.videoDuration < 0.6;
  }

  // 进度条
  progresJudgment(currentTime) {
    return currentTime / this.videoDuration < 0.9;
  }

  // vedio播放进度更新
  async progressUpdate(currentTime) {
    // 首次触发回调startTimeStamp清零，第二次触发时开始计算时长
    if (this.isFirstRun) {
      this.startTimeStamp = new Date().getTime();
      this.isFirstRun = false;
      return;
    }

    this.updateProgressStorage(currentTime);

    // 暂停时，暂停回调优先触发，此时startTimeStamp应该清零处理，所以交由暂停回调负责
    if (!this.isPause) {
      this.duration += new Date().getTime() - this.startTimeStamp;
      this.startTimeStamp = new Date().getTime();
    }

    if (this.progresJudgment(currentTime) || this.durationJudgment()) {
      return;
    }

    if (this.canRepoty()) {
      this.report();
    }
  }

  updateProgressStorage (currentTime) {
    const userId = window.$nuxt.$store.state.user.userInfo?.userid;
    if (!userId) {
      return false;
    }
    const progress = ((currentTime / this.videoDuration) * 100).toFixed();
    CourseProgressStorage.updateProgress(userId, this.postId, progress);
  }

  canRepoty() {
    return !sessionStore.get(`report-sid-${this.key}`);
  }

  async report() {
    const userId = window.$nuxt.$store.state.user?.userInfo?.userid;
    if (userId) {
      const res = await LearningService.userpostread({
        post_type: this.postType,
        post_id: Number(this.postId),
      }).catch(() => null);

      if (!res.error) {
        sessionStore.set(`report-sid-${this.key}`, true);
      }
    }

    if (this.reportHook) {
      this.reportHook();
    }
  }
}

export default LearngingReport;
